import React from "react";
import { Button } from "../../../common/Button/Button";
import moment from "moment";
import { getUser } from "../../../utils/localStorage";
//sEmailAddress
export default function ServiceDetailsTable(props) {
	const LS_FIELDS = [
		{ key: "leadsquared_lead_url", name: "LS URL" },
		{ key: "FirstName", name: "First Name" },
		{ key: "LastName", name: "Last Name" },

		{ key: "EmailAddress", name: "Email Address" },
		{ key: "Phone", name: "Phone" },
		{ key: "mx_City", name: "City" },
		{ key: "mx_State", name: "State" },

		{ key: "Mobile", name: "Mobile" },

		{ key: "mx_Contact_URL_Email", name: "Conatct URL Email" },

		{ key: "mx_Contact_URL_Phone_1", name: "Contact URL Phone 1" },

		{ key: "mx_Contact_URL_Phone_2", name: "Contact URL Phone 2" },

		{ key: "CreatedOn", name: "Created On" },

		{ key: "mx_DND_Consent_Expiry_Date", name: "DND Consent Expiry Date" },
		{ key: "OwnerIdName", name: "Owner Id Name" },
		{ key: "Source", name: "Lead Source" },

		{ key: "mx_Source_Specific", name: "Source Specific" },
		{ key: "mx_Campaign_specific", name: "Campaign_Specific" },
		{ key: "ProspectStage", name: "Lead Stage" },

		{ key: "mx_substage1", name: "Substage" },
		{ key: "mx_Reasons_for_No_Show", name: "Reason for no show" },
		{ key: "mx_Reasons_for_Case_Closed", name: "Reason for case closed" },

		{ key: "LeadAge", name: "Lead Age" },

		{ key: "mx_Latest_VOC_Member", name: "Latest VOC Member" },
		{ key: "mx_Gender", name: "Gender" },

		{ key: "mx_Benefited_Channel", name: "Benefited Channel" },
		{ key: "mx_SelfRegisteredOnWebsite", name: "SelfRegisteredOnWebsite" },
		{ key: "mx_Udyog_Guide", name: "Udyog Guide" },

		// { key: "ProspectAutoId", name: "Prospect Auto Id" },
	];
	/**
	 * city, area of operation,  udyog guide, counsellor
	 */
	/**
	 * {moment(moment.utc(e["dtServiceProgression"]).toDate()).format(
                "MMMM Do YYYY, h:mm:ss a"
              )}
	 */
	const LS_DATE_FIELDS = ["CreatedOn", "mx_DND_Consent_Expiry_Date"];
	const renderServicesTableLS = () => {
		if (!props.data) return;
		let temp = props.data.map((e, index) => {
			let temp1 = Object.entries(LS_FIELDS).map(([key, value], index) => {
				if (index < 11) {
					return (
						<div
							style={{
								borderBottom: "1px solid #d6d6d6",
							}}
							className="row"
						>
							<div className="col-md-3">
								<span className="ml-30">{value["name"]}:</span>
							</div>

							<div className="col-md-3">
								{value["key"] === "leadsquared_lead_url" ? (
									<a href={e[value["key"]]} target="_blank">
										{" "}
										LS URL{" "}
									</a>
								) : value["key"] === "mx_Contact_URL_Email" ||
								  value["key"] === "mx_Contact_URL_Phone_1" ||
								  value["key"] === "mx_Contact_URL_Phone_2" ? (
									<a href={e[value["key"]]} target="_blank">
										{" "}
										{e[value["key"]]}
									</a>
								) : (
									<span>{e[value["key"]]}</span>
								)}
							</div>
							<div className="col-md-3">
								<span>{LS_FIELDS[11 + index]["name"]}</span>
							</div>
							<div className="col-md-3">
								{LS_DATE_FIELDS.includes(value["key"]) ? (
									<span>
										{moment(
											moment
												.utc(
													e[
														LS_FIELDS[11 + index][
															"key"
														]
													]
												)
												.toDate()
										).format("MMMM Do YYYY, h:mm:ss a")}
									</span>
								) : (
									<span>
										{e[LS_FIELDS[11 + index]["key"]]}
									</span>
								)}
							</div>
						</div>
					);
				}
				if (index > 23) {
					return (
						<div className="row">
							<div className="col-md-3">
								<></>
							</div>

							<div className="col-md-3">
								<></>
							</div>
							<div
								className="col-md-3"
								style={{
									borderBottom: "1px solid #d6d6d6",
								}}
							>
								<span>{LS_FIELDS[index]["name"]}</span>
							</div>
							<div
								className="col-md-3"
								style={{
									borderBottom: "1px solid #d6d6d6",
								}}
							>
								<span>{e[LS_FIELDS[index]["key"]]}</span>
							</div>
						</div>
					);
				}
			});
			return (
				<div
					style={{
						marginBottom: "50px",
						borderBottom: "1px solid grey",
					}}
				>
					<div>{temp1}</div>
				</div>
			);
		});

		return <div>{temp}</div>;
	};
	const renderServicesTableLPM = () => {
		if (!props.data) return;
		let temp = props.data.map((e) => {
			return (
				<tr>
					<td>{e["nResourceInstanceId"]}</td>
					<td>{e["sServiceName"]}</td>
					<td>{e["business_sector_name"]}</td>
					<td>{e["sBusinessName"]}</td>
					<td>{e["refSRState"]==="Cancelled"?(<span style={{cursor:"pointer"}}  title={e["sSRCancellationReason"]?
								e["sSRCancellationReason"] ==="Other"? 
								e["sSRCancellationReasonOtherDescription"]: 
								e["sSRCancellationReason"]:""}>{e["refSRState"]}</span>):(e["refSRState"])}</td>
					<td>{e["sFollowupAction"]}</td>
					<td>
						{moment(moment.utc(e["dtFollowupOn"]).toDate()).format(
							"MMMM Do YYYY, h:mm:ss a"
						)}
					</td>
					<td>{e["refHH"]}</td>
					<td>
						{e["existing_service_facilitator"]
							? e["existing_service_facilitator"]["email"]
							: ""}
					</td>
					<td>
						{e["existing_service_facilitator"]
							? e["existing_service_facilitator"]["is_active"]
								? e["existing_service_facilitator"][
										"out_of_office"
								  ]
									? "Out of Office"
									: "Active"
								: "Deactivated"
							: ""}
					</td>

					<td>{e["sEmailAddress"]}</td>
					<td>{e["sContactNumber"]}</td>
					<td>{e["nUserId"]}</td>
				</tr>
			);
		});
		return temp;
	};

	const renderServicesTableColumnsLPM = () => {
		return (
			<tr>
				<th>Instance Id</th>
				<th>Service Name</th>
				<th>Business Sector Name</th>
				<th>Business Name</th>
				<th>Service Status</th>
				<th>Followup Action</th>
				<th>Followup Date</th>
				<th>HH Email</th>
				<th>Recent Service Facilitator</th>
				<th>Facilitator Status</th>
				<th>SR Email Id</th>
				<th>SR Phone Number</th>
				<th>SR User Id</th>
			</tr>
		);
	};
	const renderServicesTableColumnsSPMSectionA = () => {
		return (
			<tr>
				<th>Instance Id</th>
				<th>Service Name</th>
				<th>Business Sector Name</th>
				<th>Business Name</th>
				<th>Service Status</th>
				<th>Facilitator Email</th>
				<th>Followup Date</th>
				<th>SR Email Id</th>
				<th>SR Phone Number</th>
				<th>SR User Id</th>
				<th>Notes</th>
			</tr>
		);
	};
	const renderServicesTableSPMSectionA = () => {
		if (!props.data) return;
		let temp = props.data.map((e) => {
			return (
				<tr>
					<td>{e["nResourceInstanceId"]}</td>
					<td>{e["refServiceType"]["sServiceName"]}</td>
					<td>{e["refBusinessSectorNew"] && e["refBusinessSectorNew"]["sSectorName"]}</td>
					<td>{e["sBusinessName"]}</td>
					<td>{e["refSRState"]==="Cancelled"?(<span style={{cursor:"pointer"}}  title={e["sServiceCancellationReason"]?
								e["sServiceCancellationReason"] ==="Other"? 
								e["sServiceCancellationReasonOtherDescription"]: 
								e["sServiceCancellationReason"]:""}>{e["refSRState"]}</span>):(e["refSRState"])}</td>
					<td>{e["refFacilitator"]}</td>
					<td>
						{(e["dtFollowupOn"]?moment(moment.utc(e["dtFollowupOn"]).toDate()).format(
							"MMMM Do YYYY, h:mm:ss a"
						):null)}
					</td>
					<td>{e["sEmailAddressOrigin"]}</td>
					<td>{e["sContactNumber"]}</td>
					<td>{e["nUserId"]}</td>
					<td>
						<Button onClick={() => props.toggleNotesModal(e)}>
							Add
						</Button>
					</td>
				</tr>
			);
		});
		return temp;
	};
	const renderServicesTableColumnsSPMSectionB = () => {
		return (
			<tr>
				<th>Instance Id</th>
				<th>Service Name</th>
				<th>Business Sector Name</th>
				<th>Business Name</th>
				<th>Service Status</th>
				<th>Facilitator Email</th>
				<th>Followup Date</th>
				<th>SR Email Id</th>
				<th>SR Phone Number</th>
				<th>SR User Id</th>
				<th>User Profile Email</th>
				<th>User Profile Phone</th>
				<th>Notes</th>
			</tr>
		);
	};
	const renderServicesTableSPMSectionB = () => {
		if (!props.data) return;
		let temp = props.data.map((e) => {
			return (
				<tr>
					<td>{e["nResourceInstanceId"]}</td>
					<td>{e["refServiceType"]["sServiceName"]}</td>
					<td>{e["refBusinessSectorNew"] && e["refBusinessSectorNew"]["sSectorName"]}</td>
					<td>{e["sBusinessName"]}</td>
					<td>{e["refSRState"]==="Cancelled"?(<span style={{cursor:"pointer"}} title={e["sServiceCancellationReason"]?
								e["sServiceCancellationReason"] ==="Other"? 
								e["sServiceCancellationReasonOtherDescription"]: 
								e["sServiceCancellationReason"]:""}>{e["refSRState"]}</span>):(e["refSRState"])}</td>
					<td>{e["refFacilitator"]}</td>
					<td>
						{(e["dtFollowupOn"]?moment(moment.utc(e["dtFollowupOn"]).toDate()).format(
							"MMMM Do YYYY, h:mm:ss a"
						):null)}
					</td>
					<td>{e["sEmailAddressOrigin"]}</td>
					<td>{e["sContactNumber"]}</td>
					<td>{e["nUserId"]}</td>
					<td>{e["customer_meta"] && e["customer_meta"]["email"]}</td>
					<td>
						{e["customer_meta"] &&
							e["customer_meta"]["mobile_number"]}
					</td>
					<td>
						<Button onClick={() => props.toggleNotesModal(e)}>
							Add
						</Button>
					</td>
				</tr>
			);
		});
		return temp;
	};

	return props.data ? (
		<>
			<div className="row">
				<div className="col-md-10" style={{marginBottom:'5px'}}>
					<span>
						<b>{props.label}</b>
					</span>
				</div>
				{(props.SPMServices || props.label ==="Lead Details from LS") ? (
					""
				) : (
					<div
						style={{
							paddingRight: '10px',
						}}
						className={`${
							props.disableAssignToMe ? "" : "disable"
						} col-md-2`}
					>
						<Button
							style={{
								float: "right",
							}}
							onClick={() => props.assignToMeClick(props.nUserId)}
						>
							Assign to me
						</Button>
					</div>
				)}
			</div>
			{props.LSServices ? (
				<div style={{ marginTop: "10px" }}>
					{renderServicesTableLS()}
				</div>
			) 
			: 
			(
				<div style={{maxHeight:"400px",overflow:"auto"}}>
						<table className="three-sixty-service-details-table">
							<thead>
								{props.LSServices
									? ""
									: props.SPMServices
									? props.section === "A"
										? renderServicesTableColumnsSPMSectionA()
										: renderServicesTableColumnsSPMSectionB()
									: renderServicesTableColumnsLPM()}
							</thead>
							<tbody>
								{props.LSServices
									? ""
									: props.SPMServices
									? props.section === "A"
										? renderServicesTableSPMSectionA()
										: renderServicesTableSPMSectionB()
									: renderServicesTableLPM()}
							</tbody>
						</table>
					</div>
			)}
		</>
	) : (
		<div className="col-md-10">
			<span>
				<b>{props.label}</b>
			</span>
			<div>
				<span>
					<b>No data found</b>
				</span>
			</div>
		</div>
	);
}

/** */
